import React from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';

import { AuthService } from '../services/authentication.service';

interface PrivateRouteProps extends RouteProps {
    component: any;
    roles?: any;
}

export const PrivateRoute = (props: PrivateRouteProps) => {
    const { component: Component, roles, ...rest } = props;
      
    return (
        <Route {...rest} render={(routeProps) => {
            if (!AuthService.loggedIn()) {
                // not logged in so redirect to login page with the return url
                return <Redirect to={{ pathname: '/login', state: { from: routeProps.location } }} />
            }
    
            // check if route is restricted by role
            let user = AuthService.getProfile();
            if (roles && user && user.roles && !user.roles.some(r => roles.indexOf(r) >= 0)) {
                // role not authorised so redirect to home page
                return <Redirect to={{ pathname: '/'}} />
            }
    
            // authorised so return component
            return <Component {...routeProps} />
        }} />
    );
};